import React, {Component} from "react"

import {BasketItemType, Product, Deal} from "@irati/types"
import {H1} from "@irati/ui/src/Typography"
import FormattedMessage, {injectIntl, InjectIntl} from "@irati/utils/lang"
import isTimeLimited from "@irati/deals/helpers/deals/isTimeLimited"
import Form from "@irati/ui/src/Form"
import {Select} from "@irati/ui/src/FormItem"
import basket from "@irati/checkout/utils/basket"
import withPerkOrReward, {WithPerkOrReward} from "@irati-web/flexi-rewards/src/utils/withPerkOrReward"

import TimeLimitedDeal from "./shared/TimeLimitedDeal"
import LimitWrapper from "./shared/LimitWrapper"
import QuantityContainer from "./shared/Quantity/QuantityContainer"
import {QuantityOnChange} from "./shared/Quantity/QuantityItem"

interface Props extends InjectIntl, WithPerkOrReward {
  products: Product[]
  deal: Deal
  allowMultipleQuantity?: boolean
}

interface State {
  selectedProduct: Product | null
}

class SingleProduct extends Component<Props, State> {
  state: State = {
    selectedProduct: null
  }

  selectProduct = (productUuid: string, isRewards?: boolean) => {
    basket.clear()
    if (productUuid) {
      this.setState({
        selectedProduct: this.props.products.find((prod) => prod.uuid === productUuid) || null
      })
      if (!this.props.allowMultipleQuantity) {
        const entityType = isRewards ? BasketItemType.FlexiReward : BasketItemType.Deal
        basket.setProduct(entityType, this.props.deal.uuid!, productUuid, {count: 1})
      }
    } else {
      this.setState({selectedProduct: null})
    }
  }

  handleUpdateQuantity: QuantityOnChange = (type) => {
    const {selectedProduct} = this.state
    const {isRewards} = this.props
    if (selectedProduct) {
      let count = basket.items.find((t) => t.productId === selectedProduct?.uuid)?.count || 0
      if (type === "+") {
        count++
      } else {
        count--
      }
      const entityType = isRewards ? BasketItemType.FlexiReward : BasketItemType.Deal
      basket.setProduct(entityType, this.props.deal.uuid!, selectedProduct.uuid, {count})
    }
  }

  render() {
    const {deal, products, formatMessage, allowMultipleQuantity} = this.props
    const {selectedProduct} = this.state

    const options = products.map((item) => {
      // TODO readd stock check on disabled property
      return {
        value: item.uuid,
        label: item.name
      }
    })

    return (
      <>
        <H1 marginBottom={2}>
          <FormattedMessage id="perks.components.productForms.singleProductSelection.title" />
        </H1>
        {isTimeLimited(deal) && <TimeLimitedDeal deal={deal} />}
        <LimitWrapper deal={deal}>
          <Form>
            <Select
              placeholder={formatMessage({id: "perks.components.productForms.singleProductSelection.select"})}
              value={selectedProduct && selectedProduct.uuid}
              isClearable={false}
              isSearchable={false}
              name="selectedProduct"
              onChange={(value) => this.selectProduct(value, this.props.isRewards)}
              options={options}
            />
          </Form>
          {allowMultipleQuantity && selectedProduct && (
            <QuantityContainer
              deal={deal}
              products={products.filter((item) => item.uuid === selectedProduct.uuid)}
              handleClick={this.handleUpdateQuantity}
            />
          )}
        </LimitWrapper>
      </>
    )
  }
}

export default withPerkOrReward(injectIntl(SingleProduct))
